import React from 'react';

export const ActivoFichaPrint = React.forwardRef(({ data, accesorios }, ref) => {
    return (
        <div ref={ref} className="p-5" style={{ backgroundColor: 'white', minHeight: '100vh' }}>
            {/* TÍTULO EN AZUL PARA DIFERENCIARLO DEL REMITO */}
            <div className="d-flex justify-content-between align-items-center border-bottom border-primary border-3 pb-3 mb-4">
                <h1 style={{ color: '#0d6efd', fontWeight: 'bold' }}>FICHA TÉCNICA DE ACTIVO</h1>
                <div className="text-end">
                    <span className="badge bg-dark p-2">CÓDIGO: {data.codigo}</span>
                </div>
            </div>

            <div className="row">
                <div className="col-8">
                    <table className="table table-bordered">
                        <tbody>
                            <tr><td className="bg-light fw-bold">Nombre:</td><td>{data.nombre}</td></tr>
                            <tr><td className="bg-light fw-bold">Marca:</td><td>{data.marca || '---'}</td></tr>
                            <tr><td className="bg-light fw-bold">N° Serie:</td><td>{data.serie || '---'}</td></tr>
                            <tr><td className="bg-light fw-bold">Energía:</td><td>{data.tipo_energia || '---'}</td></tr>
                            <tr><td className="bg-light fw-bold">Ubicación:</td><td>{data.ubicacion || '---'}</td></tr>
                        </tbody>
                    </table>
                    
                    <h5 className="mt-4 fw-bold text-secondary">ACCESORIOS</h5>
                    <div className="p-3 border rounded bg-light">
                        {accesorios && accesorios.length > 0
                            ? accesorios.map((a, i) => (
                                <span key={i} style={{ display: 'inline-block', marginRight: '12px', marginBottom: '4px' }}>
                                    <strong>{typeof a === 'object' ? a.nombre : a}</strong>
                                    {typeof a === 'object' && <span style={{ color: '#666' }}> ({a.cantidad} u.)</span>}
                                </span>
                              ))
                            : 'Sin accesorios'}
                    </div>
                </div>
                
                <div className="col-4 text-center">
                    <div className="border p-2 rounded bg-white">
                        <p className="small fw-bold text-muted">FOTO DEL ACTIVO</p>
                        {data.foto_url ? (
                            <img src={data.foto_url} style={{ width: '100%', height: 'auto', borderRadius: '8px' }} alt="Activo" />
                        ) : (
                            <div className="py-5 bg-light text-muted">Sin Foto</div>
                        )}
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <h5 className="fw-bold text-secondary">OBSERVACIONES / DESCRIPCIÓN</h5>
                <p className="p-3 border rounded">{data.descripcion || 'Sin descripción.'}</p>
            </div>
        </div>
    );
});